import { connect } from 'react-redux';
import Auth from './Auth';
import {
  auth,
  getUrlWebSSOLogin,
  getUrlWebSSOLogout
} from '../../store/actions/auth';
import { userGetInfo, userCorporate, userGetInfoClear } from '../../store/actions/user';

const mapStateToProps = ({ authReducer, userReducer }) => ({ authReducer, userReducer });
const mapDispatchToProps = {
  auth,
  userGetInfo,
  userCorporate,
  userGetInfoClear,
  getUrlWebSSOLogin,
  getUrlWebSSOLogout
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Auth);
